import { createSlice } from "@reduxjs/toolkit"

export const TransactionSlice = createSlice({
    name: "transaction",
    initialState: {
        transactionList: [],
        singleDetail: {},
        isFreshData: false,
        totalEntryAccepted: 0,
    },
    reducers: {
        setTransactionList: (state, action) => {
            state.transactionList = action.payload
        },
        
        setFreshList: (state, action) => {
            state.isFreshData = action.payload
        },
        
        setTotalEntry: (state, action) => {
            state.totalEntry = action.payload
        },
        
        setSingleData: (state, action) => {
            state.singleDetail = action.payload
        }
    }
})

export const {
    setTransactionList,
    setFreshList,
    setSingleData,
    setTotalEntry,
} = TransactionSlice.actions

export const selectTransactionList = (state) => state.transaction.transactionList
export const selectTransactionAcceptList = (state) => state.transaction.transactionAcceptList
export const selectFreshList = (state) => state.transaction.isFreshData
export const selectTotalEntry = (state) => state.transaction.totalEntry
export const selectSingleDetail = (state) => state.transaction.singleDetail

export default TransactionSlice.reducer
